import { Box, Center, Link, Text } from '@chakra-ui/react';
import { useParams, Link as RRLink } from 'react-router-dom';
import { useFetchEnhancedOrder } from '../../state/server-side/queries/order';
import LoadingPage from '../../pages/loading';
import OrderDetails from './order-details';
import { GitsHarRecallsInfo } from '../order/header/gits-har-recalls/info';
import { isAfter, isBefore, set } from 'date-fns';
import { FaLongArrowAltRight, FaPercent } from 'react-icons/fa';
import { SuzukiGarantieProInfo } from '../order/header/suzuki-garantie-pro/info';

const campaigns = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500].map(value => ({
	id: `HVGC${value}S`,
	name: `Routine Paris - Cashback ${value} RON`,
	voucherValue: value,
	startDate: new Date('2026-01-16'),
	endDate: set(new Date('2026-02-15'), { hours: 23, minutes: 59, milliseconds: 999 }),
	restrictByWorkOrderType: ['MECANICA'],
}));

const isAnyCampaignActive = () => {
	const now = new Date();
	return campaigns.some(campaign => isAfter(now, campaign.startDate) && isBefore(now, campaign.endDate));
};

const MainLayout = ({ children, ...props }) => {
	const { orderId } = useParams();
	// const { data, isLoading, isError } = useFetchOrder(orderId);
	const { data, isLoading, isError } = useFetchEnhancedOrder(orderId);

	const isCampaignActive = isAnyCampaignActive();

	if (isLoading) {
		return <LoadingPage offset={64} />;
	}

	if (isError) {
		return <div>error</div>;
	}

	return (
		<Box display={'flex'} flexDirection={'column'} mb={8}>
			{isCampaignActive ? (
				<Link
					as={RRLink}
					to={`/${orderId}/campanii-promotionale`}
					display="flex"
					alignItems="center"
					justifyContent="flex-start"
					gap={2}
					ml={4}
					fontSize={'lg'}
					color="green.300"
					_hover={{ color: 'blue.300', textDecoration: 'underline' }}
				>
					<FaPercent />
					<Text>Campanii promotionale</Text>
					<FaLongArrowAltRight />
				</Link>
			) : null}
			<Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} mb={8}>
				<OrderDetails data={data} mt={isCampaignActive ? 2 : 6} />
				<GitsHarRecallsInfo order={data} />
				<SuzukiGarantieProInfo order={data} />
			</Box>
			<Center h={'100%'} {...props}>
				{children}
			</Center>
		</Box>
	);
};

export default MainLayout;
